import { createFileRoute } from "@tanstack/react-router";
import { CreditCard, Sparkles, QrCode } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import heroImg from "@/assets/hero-card.webp";

export const Route = createFileRoute("/platform/identity-and-sharing")({
  head: () => ({
    meta: [
      { title: "Identity & Sharing — banana.cards" },
      { name: "description", content: "Digital business cards, premium NFC products, and every share channel — QR, Wallet, links, email signatures." },
      { property: "og:title", content: "Identity & Sharing — banana.cards" },
      { property: "og:description", content: "Digital business cards, premium NFC products, and every share channel — QR, Wallet, links, email signatures." },
      { property: "og:image", content: heroImg },
      { property: "og:url", content: "https://banana.cards/platform/identity-and-sharing" },
    ],
    links: [{ rel: "canonical", href: "https://banana.cards/platform/identity-and-sharing" }],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Identity & Sharing"
      title="One identity,"
      italic="every channel."
      description="A beautiful digital business card, a premium NFC product to share it with a tap, and every networking tool you need to turn taps into conversations."
      heroImage={heroImg}
      heroImageAlt="Digital identity and sharing controls on a Banana NFC business card with per-audience visibility rules"
      features={[
        { title: "Digital Business Cards", desc: "Beautiful, customizable profiles for every person on your team — with links, media and CTAs.", href: "/platform/cards", icon: CreditCard, bullets: ["Drag-and-drop editor", "Custom branding & themes", "Multiple cards per user"] },
        { title: "NFC Cards", desc: "Premium NFC products in metal, bamboo, PVC and 24kt gold — built to last and tap to share.", href: "/platform/nfc", icon: Sparkles, bullets: ["6 premium materials", "Custom artwork", "Re-program anytime"] },
        { title: "Sharing & Networking", desc: "QR, Apple & Google Wallet, email signatures, exchange forms and PIN protection — every share channel covered.", href: "/platform/sharing", icon: QrCode, bullets: ["6 networking tools", "Tracked & analytics-ready", "Apple & Google Wallet"] },
      ]}
      outro={{ title: "Your identity, ", italic: "everywhere.", description: "One profile, every device, every channel — sharable in seconds." }}
    />
  );
}